import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=3b7ee2b0"
import script from "./BaseSnackbar.vue?vue&type=script&lang=js"
export * from "./BaseSnackbar.vue?vue&type=script&lang=js"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=3b7ee2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports